// extracted by css-extract-rspack-plugin
export default {"Legend":"Legend--CDkx8"};